import { render } from "./RootSidebar.vue?vue&type=template&id=12f85a32&scoped=true"
import script from "./RootSidebar.vue?vue&type=script&lang=js"
export * from "./RootSidebar.vue?vue&type=script&lang=js"

import "./RootSidebar.vue?vue&type=style&index=0&id=12f85a32&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12f85a32"]])

export default __exports__